import React, { useState, useRef } from 'react';
import c from 'classnames';
import { useOnOutsideClick } from '@wix/da-hooks/pkg/useOnOutsideClick';
import EllipsisIcon from '@wix/da-ds/pkg/Icons/Ellipsis';
import SelectionListCard from '@wix/da-ds/pkg/SelectionList/SelectionListCard';
import IconButtonWithBackground from '@wix/da-ds/pkg/Buttons/IconButton/IconButtonWithBackground';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import { DeviationResourceType } from '../../types/deviation';
import TierCreatorReduxModule from '../redux/creator/ModuleLoadable';
import TierConsumerReduxModule from '../redux/consumer/ModuleLoadable';
import { useSubscriptionTier } from '../../utils/hooks/useSubscriptionTier';
import DeleteTier from '../ActionItems/DeleteTier';
import EditTier from '../ActionItems/EditTier';
import GoToTier from '../ActionItems/GoToTier';
import ManageTier from '../ActionItems/ManageTier';
import ShareInPost from '../ActionItems/ShareInPost';
import ShareOnSocial from '../ActionItems/ShareOnSocial';
import ConnectDiscord from '../ActionItems/ConnectDiscord';
import s from './MoreActionsButton.scss';
var MoreActionsButton = function (_a) {
    var _b;
    var isOwner = _a.isOwner, deviation = _a.deviation, className = _a.className;
    var _c = useState(false), isMenuShown = _c[0], setIsMenuShown = _c[1];
    var isUserSubscribed = useSubscriptionTier(deviation).isUserSubscribed;
    var isDraft = ((_b = deviation.tier) === null || _b === void 0 ? void 0 : _b.state) === 'draft';
    var rootRef = useRef(null);
    useOnOutsideClick([rootRef], function () { return setIsMenuShown(false); });
    var toggleMenuVisibility = function () { return setIsMenuShown(!isMenuShown); };
    var renderOwnerMenuItems = function () { return (React.createElement(React.Fragment, null,
        !isDraft && React.createElement(GoToTier, { deviation: deviation }),
        React.createElement(EditTier, { deviation: deviation }),
        !isDraft && React.createElement(ShareOnSocial, { deviation: deviation }),
        !isDraft && React.createElement(ShareInPost, { deviation: deviation }),
        React.createElement(DeleteTier, { deviation: deviation }),
        React.createElement(TierCreatorReduxModule, null))); };
    var renderVisitorMenuItems = function () { return (React.createElement(React.Fragment, null,
        React.createElement(GoToTier, { deviation: deviation }),
        React.createElement(ShareOnSocial, { deviation: deviation }),
        isUserSubscribed && (React.createElement(React.Fragment, null,
            React.createElement(ConnectDiscord, { deviation: deviation }),
            React.createElement(ManageTier, { deviation: deviation }))),
        React.createElement(TierConsumerReduxModule, null))); };
    return (React.createElement("div", { className: c(s['root'], className), ref: rootRef },
        React.createElement(IconButtonWithBackground, { icon: EllipsisIcon, size: IconSize.MEDIUM, onClick: toggleMenuVisibility, biData: isMenuShown
                ? undefined
                : {
                    evid: BiEventType.MORE_MENU_CLICK,
                    typeid: DeviationResourceType.TIER,
                    itemid: deviation.deviationId,
                    sectionname: 'tiers',
                } }),
        isMenuShown && (React.createElement(SelectionListCard, { className: s['menu'] }, isOwner ? renderOwnerMenuItems() : renderVisitorMenuItems()))));
};
MoreActionsButton.displayName = 'MoreActionsButton';
export default MoreActionsButton;
//# sourceMappingURL=MoreActionsButton.js.map